import { object, ObjectSchema, string } from 'yup';

import { SetPriceWithProductPayload } from '@client/api';

import { intervalValueSchema } from './IntervalValue.schema';
import { invoicingIntegrationExternalReferenceValueSchema } from './InvoicingIntegrationExternalReferenceValue.schema';
import { moneyValueSchema } from './MoneyValue.schema';

const schema: ObjectSchema<SetPriceWithProductPayload> = object({
  unitAmount: moneyValueSchema,
  interval: intervalValueSchema.nullable().makeOptional(),
  description: string().nullable(),
  source: invoicingIntegrationExternalReferenceValueSchema.nullable().makeOptional(),
  id: string().nullable(),
  productId: string().required()
});

export { schema as setPriceWithProductPayloadSchema };
